import React, { useState, useEffect } from 'react'
import UsersList from './UsersList'
import firebase from "../../../Firebase/firebase"
import {useHistory} from 'react-router-dom'
import {
  getClientId, User,checkUser, selectedUser, ActiveUsers, ActiveUserCrew, ActiveUserGround, ActiveUserSimulator,
  ActiveUserAircraft, user_active, aircraft_active, crew_active, ground_active, simulator_active, register_active
} from '../../../Queries/Manager Query/Users/User'
import { useQuery, useMutation } from "@apollo/client";

const Users = () => {
  const [add_new_crew, setadd_new_crew] = useState(false)
  const [toggle, settoggle] = useState(true)
  const [users, setusers] = useState({})
  const History = useHistory()
  const [aircraft1, setAircraft1] = useState(true)
  const [crew1, setCrew1] = useState(true)
  const [ground1, setGround1] = useState(true)
  const [simulator1, setsimulator1] = useState(true)
  const [managerr1, setmanagerr1] = useState(false)
  const [optimiser1, setoptimiser1] = useState(false)
  const [dataAdmin1, setdataAdmin1] = useState(false)
  const [Active1, setActive1] = useState(true)
  const closeForm = () => {
    setadd_new_crew(false)
  };
  const togle = () => {
    toggle ? settoggle(false) : settoggle(true)
  }
 
  useEffect(() => {
    firebase.auth().onAuthStateChanged(async user => {
      if (user) {
        const token = await user.getIdToken();
        const idTokenResult = await user.getIdTokenResult();
        setusers({
          user: user,
          token: idTokenResult,
          jwt: token
        })
      }
      else console.log("SIGNED OUT");
    })
  }, [])

  const {data:checkusers} = useQuery(checkUser,{
    variables:{id: users?.token?.claims?.user_id}
  })
  useEffect(() => {
    if(users && checkusers?.aatmsv4_managers[0]?.canedituser === false){
      History.push("/dashboard/manager")
    }
  }, [])
  const { data: getclient } = useQuery(getClientId, {
    variables: { id: users?.token?.claims?.user_id }
  })
  const { data: getusers } = useQuery(User, {
    variables: {
      id: getclient?.aatmsv4_users[0]?.client?.clientsid,
      Active: toggle
    }
  })

  const [ActiveUserss, { data: ac }] = useMutation(ActiveUsers, {
    refetchQueries: [{
      query: User, variables: {
        id: getclient?.aatmsv4_users[0]?.client?.clientsid,
        Active: true
      }
    }, {
      query: User, variables: {
        id: getclient?.aatmsv4_users[0]?.client?.clientsid,
        Active: false
      }
    }]
  })
  const [ActiveUserssCrews, { data: cr }] = useMutation(ActiveUserCrew, {
    refetchQueries: [{
      query: User, variables: {
        id: getclient?.aatmsv4_users[0]?.client?.clientsid,
        Active: true
      }
    }, {
      query: User, variables: {
        id: getclient?.aatmsv4_users[0]?.client?.clientsid,
        Active: false
      }
    }]
  })
  const [ActiveUserssGroundss, { data: gr }] = useMutation(ActiveUserGround, {
    refetchQueries: [{
      query: User, variables: {
        id: getclient?.aatmsv4_users[0]?.client?.clientsid,
        Active: true
      }
    }, {
      query: User, variables: {
        id: getclient?.aatmsv4_users[0]?.client?.clientsid,
        Active: false
      }
    }]
  })
  const [ActiveUsersssimulatorss, { data: sims }] = useMutation(ActiveUserSimulator, {
    refetchQueries: [{
      query: User, variables: {
        id: getclient?.aatmsv4_users[0]?.client?.clientsid,
        Active: true
      }
    }, {
      query: User, variables: {
        id: getclient?.aatmsv4_users[0]?.client?.clientsid,
        Active: false
      }
    }]
  })
  const [ActiveUserssaircraft, { data: ai }] = useMutation(ActiveUserAircraft, {
    refetchQueries: [{
      query: User, variables: {
        id: getclient?.aatmsv4_users[0]?.client?.clientsid,
        Active: true
      }
    }, {
      query: User, variables: {
        id: getclient?.aatmsv4_users[0]?.client?.clientsid,
        Active: false
      }
    }]
  })
  const [selectRole, { data: role }] = useMutation(selectedUser, {
    refetchQueries: [{
      query: User, variables: {
        id: getclient?.aatmsv4_users[0]?.client?.clientsid,
        Active: true
      }
    }, {
      query: User, variables: {
        id: getclient?.aatmsv4_users[0]?.client?.clientsid,
        Active: false
      }
    }]
  })


  const [aircraft_actives, { data: aractivess }] = useMutation(aircraft_active, {
    refetchQueries: [{
      query: User, variables: {
        id: getclient?.aatmsv4_users[0]?.client?.clientsid,
        Active: true
      }
    }, {
      query: User, variables: {
        id: getclient?.aatmsv4_users[0]?.client?.clientsid,
        Active: false
      }
    }]
  })
  const [crew_actives, { data: crwe }] = useMutation(crew_active, {
    refetchQueries: [{
      query: User, variables: {
        id: getclient?.aatmsv4_users[0]?.client?.clientsid,
        Active: true
      }
    }, {
      query: User, variables: {
        id: getclient?.aatmsv4_users[0]?.client?.clientsid,
        Active: false
      }
    }]
  })
  const [ground_activs, { data: grngd }] = useMutation(ground_active, {
    refetchQueries: [{
      query: User, variables: {
        id: getclient?.aatmsv4_users[0]?.client?.clientsid,
        Active: true
      }
    }, {
      query: User, variables: {
        id: getclient?.aatmsv4_users[0]?.client?.clientsid,
        Active: false
      }
    }]
  })
  const [simulator_actives, { data: simula }] = useMutation(simulator_active, {
    refetchQueries: [{
      query: User, variables: {
        id: getclient?.aatmsv4_users[0]?.client?.clientsid,
        Active: true
      }
    }, {
      query: User, variables: {
        id: getclient?.aatmsv4_users[0]?.client?.clientsid,
        Active: false
      }
    }]
  })
  const [users_actives, { data: ussss }] = useMutation(user_active, {
    refetchQueries: [{
      query: User, variables: {
        id: getclient?.aatmsv4_users[0]?.client?.clientsid,
        Active: true
      }
    }, {
      query: User, variables: {
        id: getclient?.aatmsv4_users[0]?.client?.clientsid,
        Active: false
      }
    }]
  })
  const [userregister, { data: reg }] = useMutation(register_active, {
    refetchQueries: [{
      query: User, variables: {
        id: getclient?.aatmsv4_users[0]?.client?.clientsid,
        Active: true
      }
    }, {
      query: User, variables: {
        id: getclient?.aatmsv4_users[0]?.client?.clientsid,
        Active: false
      }
    }]
  })

  return (
    <div className="animate__animated animate__fadeIn">
      {/* User table */}
      <div className={"users-container " + (add_new_crew ? "hide-element" : "")}>
        <UsersList
          userregister={userregister} users_actives={users_actives} simulator_actives={simulator_actives} ground_activs={ground_activs} aircraft_actives={aircraft_actives} crew_actives={crew_actives}
          ActiveUserssaircraft={ActiveUserssaircraft} ActiveUsersssimulatorss={ActiveUsersssimulatorss} ActiveUserssGroundss={ActiveUserssGroundss} ActiveUserssCrews={ActiveUserssCrews} togle={togle} selectRole={selectRole} ActiveUserss={ActiveUserss} setoptimiser1={setoptimiser1} setdataAdmin1={setdataAdmin1} setActive1={setActive1} setmanagerr1={setmanagerr1} setsimulator1={setsimulator1} setCrew1={setCrew1} setGround1={setGround1} setAircraft1={setAircraft1} managerr1={managerr1} dataAdmin1={dataAdmin1} optimiser1={optimiser1} simulator1={simulator1} ground1={ground1} crew1={crew1} aircraft1={aircraft1} Active1={Active1} users={users} getusers={getusers} />
      </div>
    </div>
  )
}

export default Users